import { render, staticRenderFns } from "./NotesBlock.vue?vue&type=template&id=2a266bc4&"
import script from "./NotesBlock.vue?vue&type=script&lang=ts&"
export * from "./NotesBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VLazy,VTextarea})
